<template>
  <tender-form-label :key="index" :label="options.Name" :prop="realKey" :rules="rules">
    <bear-select v-model="form[realKey]" :attrs="attrs" :options="options" :disabled="options.Disabled" @change="selectChangeHandle"></bear-select>
  </tender-form-label>
</template>
<script>
import _ from "lodash";
import BearSelect from "~@/select/src";
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
import tenderHook from "../../../js/hooks";
import { mapState, mapGetters } from "vuex";
export default {
  name: "FormSelectDefault",
  mixins: [mixForFormItem],
  components: { BearSelect },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(["selections"]),
    realKey() {
      let { Key } = this.options;
      let { trueValue } = this.param;
      return trueValue ? `select_${Key}` : Key;
    },
    ...mapGetters(["properties"]),
    value() {
      return this.form[this.options.Key];
    },
    enumValue() {
      return this.form[this.param.EnumKey];
    },
    realValue() {
      return this.form[this.realKey];
    },
    Options() {
      return this.selectOptions();
    },
  },
  watch: {
    value(nv, ov) {
      let { param } = this;
      if (param.trueValue) {
        this.valueChangeHandle(nv);
      } else if(!param.EnumKey) {
        this.doSelectEvent(true)
      }
    },
    enumValue(nv, ov) {
      let { param } = this;
      if (param.EnumKey) {
        // console.log(param.EnumKey, nv);
        if (this.Options.length > 0) this.enumValueChangeHandle(nv);
      }
    },
    Options(nv, ov) {
      let { param } = this;
      if (param.EnumKey) {
        // console.log(param.EnumKey, nv);
        if (nv.length > 0) this.enumValueChangeHandle(this.enumValue);
      }
    },
  },
  created() {
    this.setDefaultValue();
    this.init();
  },
  mounted() {
    // if (/actionId=create/.test(location.search)) {
    //   this.init();
    // }
  },
  methods: {
    init() {
      let { param } = this;
      this.$nextTick(() => {
        if (param.trueValue) {
          this.valueChangeHandle(this.value);
        } else if (param.EnumKey) {
          this.enumValueChangeHandle(this.enumValue);
        }
        if (!param.noFirstChange) {
          this.doSelectEvent(!param.firstChange);
        }
      });
    },
    valueChangeHandle(nv) {
      let { param, realKey, form, options } = this;
      if (typeof nv === "boolean") {
        let xxx = options.Options.find((obj) => nv === (obj.Value === param.trueValue));
        form[realKey] = xxx.Value;
      } else {
        form[realKey] = "";
      }
      this.$nextTick(() => {
        this.doSelectEvent(param.noFirstChange === 'true');
      });
    },
    selectOptions() {
      let { Options, OptionsFromStore } = this.options;

      if (OptionsFromStore) {
        // if (this.param.EnumKey == "OPEN_BID_SITE") console.log(this.selections, OptionsFromStore, this.selections[OptionsFromStore]);
        return this.selections[OptionsFromStore];
      } else {
        return Options;
      }
    },
    enumValueChangeHandle(nv) {
      let { form, options, Options, param } = this;

      if (nv !== "") {
        let xxx = Options && Options.find((obj) => obj.EnumValue === nv);
        // if (this.param.EnumKey == "OPEN_BID_SITE") console.log(xxx);
        form[options.Key] = xxx ? xxx.Value : "";
      } else {
        form[options.Key] = "";
      }
      this.$nextTick(() => {
        this.doSelectEvent(param.noFirstChange);
      });
    },
    setDefaultValue() {
      let { form = {}, options = {} } = this;
      let { Key, Value, Options, Init } = options;
      let { trueValue, EnumKey, EnumValue } = this.param;
      if (!/actionId=create/.test(location.search)) {
        EnumValue = undefined;
        Value = undefined;
      }
      utils.readyToSetFormItemDefault(form, options).then(() => {
        Init && Init(form, true)
        let emptyValue = options.Multiple ? [] : "";
        let defaultValue = Value === undefined ? emptyValue : Value;
        if (trueValue !== undefined) {
          form[`select_${Key}`] = defaultValue;
          form[Key] = defaultValue === emptyValue ? "" : defaultValue === trueValue;
        } else if (EnumKey !== undefined) {
          form[EnumKey] = EnumValue === undefined ? "" : EnumValue;
          let xxx = Options.find((obj) => obj.EnumValue === form[EnumKey]);
          form[Key] = xxx ? xxx.Value : "";
        } else {
          form[Key] = defaultValue;
        }
      }).catch((e) => null);
    },
    selectChangeHandle(value) {
      let { form = {}, options = {}, Options = [] } = this;
      let { Key } = options;
      let { trueValue, EnumKey = "" } = this.param;

      if (trueValue) {
        form[`select_${Key}`] = value;
        form[Key] = value !== "" ? value === trueValue : "";
      } else if (EnumKey) {
        form[Key] = value;
        let xxx = Options.find((obj) => obj.Value === value);
        form[EnumKey] = xxx && xxx.EnumValue !== undefined ? xxx.EnumValue : "";
      } else {
        form[Key] = value;
      }

      this.$nextTick(() => {
        this.doSelectEvent(false);
      });
    },
    doSelectEvent(isOnlySet) {
      let { form = {}, options = {}, properties } = this;
      let { Key, Refs = [] } = options;
      let { trueValue } = this.param;
      Refs.forEach((eRef) => {
        let [type, ...args] = eRef;
        switch (type) {
          case "setFormItemRequired":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, value] = args;
              tenderHook.setFormItemRequired(properties, chapterIndex, sectionIndex, keys, form[Key] === value);
            });
            break;
          case "setFormItemDisabled":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, value] = args;
              tenderHook.setFormItemDisabled(properties, chapterIndex, sectionIndex, keys, form[Key] === value);
            });
            break;
          case "setFormItemValue":
            if (!isOnlySet) {
              utils.anoyFunction(() => {
                let [keys, value, same] = args;
                if (same) {
                  tenderHook.setFormItemValue(form, keys, form[Key]);
                  if (trueValue) {
                    tenderHook.setFormItemValue(form, keys, form[`select_${Key}`]);
                  }
                } else {
                  tenderHook.setFormItemValue(form, keys, value);
                }
              });
            }
            break;
          case "setFormItemVisible":
            utils.anoyFunction(() => {
              let [chapterIndex, sectionIndex, keys, values] = args;
              let value = trueValue ? form[`select_${Key}`] : form[Key];
              // 接下来写设置可见操作
              tenderHook.setFormItemVisible(properties, chapterIndex, sectionIndex, keys, values.indexOf(value) >= 0);
            });
            break;
          case "setFormItemWithCustom":
            if (!isOnlySet) {
              utils.anoyFunction(() => {
                let [type, ...x] = args;
                // console.log(form[Key], Key, this.form, 333);
                tenderHook.setFormItemWithCustom(this, type, options, ...x);
              });
              // tenderHook.refEventWater(false, this);
            }
            break;
          case "houseHooks":
          case "trafficHooks":
            tenderHook.refEvent(isOnlySet, this)
            // if(!isOnlySet) {
            // }
            break;
        }
      });
      this.doValidate();
    },
  },
};
</script>
<style>
</style>
